import { useNavigate } from "react-router-dom";

import { CommunicationListLayout } from "pages/communication/components/CommunicationListLayout";
import { useCommunicationListPage } from "pages/communication/hooks/useCommunicationListPage";
import {
  getInquiryStatusBadgeType,
  isInquiryDone,
} from "pages/communication/model/inquiryStatus";
import {
  createInquiryFilter,
  defaultStatusOptions,
} from "pages/communication/utils/communicationFilters";
import { createCommunicationColumns } from "pages/communication/utils/createCommunicationColumns";

function AskManager() {
  const navigate = useNavigate();
  const moveToInquiryDetail = (id) => {
    navigate(`/communication/ask/${id}`);
  };

  const {
    page,
    setPage,
    filteredItems,
    visibleItems,
    newPostsCount,
    itemsPerPage,
    handleSearchFilters,
    handleReset,
  } = useCommunicationListPage({
    fetchPath: "inquiries",
    filterFn: createInquiryFilter(),
  });

  const columns = createCommunicationColumns({
    titleHeader: "문의 제목",
    titleMaxLength: 12,
    writerAccessor: "user.name",
    answererAccessor: "ansUser.name",
    getStatusType: getInquiryStatusBadgeType,
    isDone: isInquiryDone,
    getAnswerTime: (row) => row.ansTime,
    onDetailClick: moveToInquiryDetail,
  });

  return (
    <CommunicationListLayout
      pageTitle="소통 - 문의관리"
      columns={columns}
      data={visibleItems}
      onRowClick={(row) => moveToInquiryDetail(row.id)}
      searchConfig={{
        dropdownOptions: ["제목만", "제목+본문", "본문만", "답변자"],
        statusOptions: defaultStatusOptions,
        defaultSelectedOption: "제목만",
        defaultSelectedStatus: "전체",
      }}
      onSearchFilters={handleSearchFilters}
      onReset={handleReset}
      newPostsCount={newPostsCount}
      totalCount={filteredItems.length}
      page={page}
      setPage={setPage}
      itemsPerPage={itemsPerPage}
    />
  );
}

export default AskManager;
